import moment from 'jalali-moment';
import React, { useState } from 'react';
import Draggable from 'react-draggable';
import { useNavigate } from 'react-router';
export default function Open() {
  const navigate=useNavigate()
  const handleDrag = (e, ui) => {
    if (ui.lastX > 240) navigate("/one/answer");
  };


  return (
    <div className="open ">
      <img src='/images/frame.png' id='frame' />
      <div className="datetime" dir="ltr">
        <div className="date">{moment().format('MMMM Do YYYY')}</div>
        <div className="time">{moment().format('h:mm')}</div>
        <div>
          <img src="/icons/options.svg" alt="" />
        </div>
      </div>
      <div className='overflow-hidden'>
        <div style={{zIndex:9}} className="d-flex position-relative p-2  w-100 justify-content-between align-items-center">
          <div>
            <img src="/icons/unlock2.svg" alt="" />
          </div>
          <div>
            <img src="/icons/lock.svg" alt="" />
          </div>
        </div>

        <div className="box" dir="ltr">
          <Draggable
            axis="x"
            handle=".handle"
            defaultPosition={{ x: 0, y: 0 }}
            position={null}
            grid={[10, 10]}
            scale={1}
            bounds="parent"
            // onStart={handleStart}
            onDrag={handleDrag}
          >
            <img src="/icons/unlock.svg" alt="" className="move handle" />
          </Draggable>
        </div>
      </div>
    </div>
  );
}
